import type { ApplicantScopedKeyArguments } from "./callScriptShared.types";

export type CallScriptResidenceKeyArguments = ApplicantScopedKeyArguments;

/**
 * Query keys for the residence ("Customer Verification") Call Script.
 *
 * Deliberately a separate namespace from `callScriptKeys` — in CAPS2 the
 * residence and employment scripts are two unrelated screens backed by
 * different question sets (CVDQ/CVSSQ vs. the income-slot types), so
 * invalidating one must never refetch the other.
 */
export const callScriptResidenceKeys = {
  all: ["callScriptResidence"] as const,
  history: (arguments_: CallScriptResidenceKeyArguments) =>
    [...callScriptResidenceKeys.all, "history", arguments_] as const,
  questions: (type: string) => [...callScriptResidenceKeys.all, "questions", type] as const,
};

/**
 * True for query keys produced by `callScriptResidenceKeys.questions` — the
 * residence counterpart of `isCallScriptQuestionsQueryKey`. The question
 * catalog is global reference data safe to persist to storage; call history
 * is applicant-specific and must not be.
 * @param {ReadonlyArray<unknown>} queryKey - A TanStack Query cache entry's key.
 * @returns {boolean} Whether the key belongs to the residence question catalog.
 */
export function isCallScriptResidenceQuestionsQueryKey(queryKey: readonly unknown[]): boolean {
  return queryKey[0] === callScriptResidenceKeys.all[0] && queryKey[1] === "questions";
}
